export default {
  name: 'ProcedureStep',

  props: {
    modDisabled: Boolean,
    modHidden: Boolean,
    modIcon: String
  },

  data: () => ({
    showDetails: false,
    number: 1,
    visible: true
  }),

  watch: {
    modHidden() {
      this.recalculate();
    }
  },

  mounted() {
    this.$parent.assignChild(this);
    if (this.modHidden) this.visible = false;
  },

  beforeDestroy() {
    this.$parent.removeChild(this);
  },

  methods: {
    toggleDetails() {
      if (this.$slots['details']) {
        this.showDetails = !this.showDetails;
      }
    },
    recalculate() {
      this.visible = !this.modHidden;
      this.$parent.recalculate(this);
    }
  }
};
